interface ReturnAllIconProps {
  className?: string
}

export const ReturnAllIcon = ({ className }: ReturnAllIconProps) => {
  return (
    <svg
      width="9"
      height="10"
      viewBox="0 0 9 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.21023 5.69061V5.00879L7.69886 2.21333V3.30424L3.48864 5.33265L3.52273 5.26447V5.43493L3.48864 5.36674L7.69886 7.39515V8.48606L2.21023 5.69061Z"
        fill="black"
      />
      <line x1="0.5" y1="9.24121" x2="0.5" y2="1.24121" stroke="black" />
    </svg>
  )
}
